import { EcaHasAppViewPermissionGuard } from './guards/has-app-view-permission/has-app-view-permission.guard';
import { EcaAuthenticatedUserResolver } from './resolver/authenticated-user/authenticated-user-resolver.service';
import { EcaIsAdministratorGuard } from './guards/is-administrator/is-administrator.guard';
import { ErrorInsufficientPermissionsLandingComponent } from './components/error-insufficient-permissions-landing/error-insufficient-permissions-landing.component';
import { EcaAuthenticatedRedirectGuard } from './guards/authenticated-redirect/authenticated-redirect.guard';
import { ErrorLoggedOutLandingComponent } from './components/error-logged-out-landing/error-logged-out-landing.component';
import { AuthenticatedLandingComponent } from './components/authenticated-landing/authenticated-landing.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EcaIsAuthenticatedGuard } from './guards/is-authenticated/is-authenticated.guard';
import { APP_BASE_HREF } from '@angular/common';
import { DefaultAppShellComponent } from './default-app-shell/default-app-shell.component';

export const APP_BASE_HREF_HASHBANG = { provide: APP_BASE_HREF, useValue: '!' };

export const routes: Routes = [
  {
    path: 'deocs-register',
    loadChildren: () => import('./deocs-register/deocs-register.module').then(m => m.DeocsRegisterModule)
  },
  {
    path: 'deocs',
    loadChildren: () => import('./deocs/deocs.module').then(m => m.DeocsModule)
  },
  {
    path: '',
    component: DefaultAppShellComponent,
    children: [
      {
        path: '',
        redirectTo: 'groups',
        pathMatch: 'full',
      },
      {
        path: 'groups',
        loadChildren: () => import('./group/group.module').then(m => m.GroupModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./user/user.module').then(m => m.UserModule)
      },
      {
        path: 'welcome',
        component: AuthenticatedLandingComponent,
        canActivate: [EcaIsAuthenticatedGuard, EcaHasAppViewPermissionGuard]
      },
      {
        path: 'denied',
        component: ErrorInsufficientPermissionsLandingComponent,
        canActivate: [EcaIsAuthenticatedGuard]
      },
      {
        path: 'login',
        component: ErrorLoggedOutLandingComponent,
        canActivate: [EcaAuthenticatedRedirectGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [
    EcaIsAuthenticatedGuard,
    EcaAuthenticatedRedirectGuard,
    EcaIsAdministratorGuard,
    EcaHasAppViewPermissionGuard,
    EcaAuthenticatedUserResolver,
  ]
})
export class AppRoutingModule { }
